import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PopupLayout from '@appbase/templates/PopupLayout/PopupLayout.vue'
import { ModalLayout } from '@appbase/templates'

@Component({
  components: { PopupLayout,ModalLayout },
})
export default class PopupViewMaster extends Vue {

  title:string= ''
  created(){
    if(this.$route.query && this.$route.query){
      var popItem = JSON.parse( this.$route.query.popupItem as string)
      this.title = popItem.subject || ''
    }
  }
}
